<template>
  <ErrorPageLayout pageTitle="Access Denied" pageDescription="It seems that you no longer have access to this page."></ErrorPageLayout>
</template>

<script>
import ErrorPageLayout from '../layouts/ErrorPageLayout.vue';
export default {
  components: { ErrorPageLayout },
  name: 'AccessDenied',
};
</script>
